import http from "@http";
import config from "@config";
import { all, call, put, select, takeLatest, spawn } from "redux-saga/effects";
import { push } from "connected-react-router";
import { getCurrentPath, getRedirect } from "@selectors";
import { HOME_PATH } from "@routes/constants";
import { route } from "@routes/helper";
import { CheckLogin } from "../constants/actions";
import actionCreators from "../actionCreator";
import { isAuthenticated } from "../selectors";
import resetPasswordSaga from "./reset-password";
import impersonateSaga from "./impersonate";
import { USER_TYPES_LANDING_PAGES, USER_TYPES } from "@modules/account/constants";
import LocalStorageService from "../../../services/LocalStorageService";
import managementActionCreators from "@modules/management/actionCreator";
import { PermissionEnum } from "@modules/account/components";

export function* onCheckRedirect(data) {
  try {
    const isLoggedIn = yield select(isAuthenticated);
    const currentPath = yield select(getCurrentPath);

    if (LocalStorageService.getImpersonate()) {
      LocalStorageService.clearImpersonate();
      yield put(push(HOME_PATH));
      return;
    }

    if (isLoggedIn && currentPath === "/") {
      const userLandingPage = USER_TYPES_LANDING_PAGES[data.user.userType];
      if (userLandingPage) {
        yield put(
          push(
            route(userLandingPage, {
              clientId: data.user.clientId,
            }),
          ),
        );
        return;
      }

      const redirect = yield select(getRedirect);
      yield put(push(redirect || HOME_PATH));
    }
  } catch (e) {
    console.error("Saga error: ", e);
    console.error("Error", e);
  }
}

export function* onCheckLogin() {
  try {
    const response = yield call(http.get, `${config.endpointBaseUrl}api/v1/profile/me`);

    const permissions = response.data.permissions.reduce(
      (acc, permission) => ({
        ...acc,
        [permission]: true,
        [PermissionEnum.APP_PRIVILEGE_MANAGEMENT_SERVICE_DESK]: !![
          USER_TYPES.ADMIN,
          USER_TYPES.SERVICE_MANAGER,
        ].includes(response.data.user.userType),
      }),
      {},
    );

    const data = {
      ...response.data,
      permissions,
    };

    yield put(
      actionCreators.AuthenticateSuccess({
        user: data.user,
        permissions,
      }),
    );

    yield put(managementActionCreators.GetMessagesReleaseVersion());

    yield onCheckRedirect(response.data);
  } catch (e) {
    console.error("Saga error: ", e);
    yield put(actionCreators.AuthenticateError(e.response));
  }
}

export function* loginSaga() {
  yield all([
    takeLatest(CheckLogin, onCheckLogin),
    spawn(resetPasswordSaga),
    spawn(impersonateSaga),
  ]);
}

export default loginSaga;
